import { Headline, PlacedHeadline } from "../components/HeadlinesBanner"
import moment from "moment"

const MIN_SPACING = 100
const MAX_SPACING = 150
const TOTAL_WIDTH = 300

function adjustBannerIndex(headlines: Headline[]): PlacedHeadline[] {
  // Sort the headlines by createdAt in ascending order
  const sortedHeadlines = headlines.sort(
    (a, b) => b.createdAt.diff(a.createdAt, "minutes")
  )

  const adjustedHeadlines: PlacedHeadline[] = []

  for (let i = 0; i < sortedHeadlines.length; i++) {
    const currentHeadline = sortedHeadlines[i]
    const lastAdjustedHeadline = adjustedHeadlines[adjustedHeadlines.length - 1]

    const adjustedHeadline: PlacedHeadline = {
      ...currentHeadline,
      bannerIndex: 0 // Placeholder value, will be overwritten later
    }

    if (lastAdjustedHeadline) {
      const minutesPassed = moment().diff(
        adjustedHeadline.createdAt,
        "minutes"
      )

      const gap = lastAdjustedHeadline.createdAt.diff(adjustedHeadline.createdAt, 'minutes')
      // Adjust the banner index if the conditions are not met
      if (gap < MIN_SPACING) {
        adjustedHeadline.bannerIndex = lastAdjustedHeadline.bannerIndex + MIN_SPACING
      } else if (gap > MAX_SPACING) {
        adjustedHeadline.bannerIndex =
          lastAdjustedHeadline.bannerIndex + MAX_SPACING + Math.sqrt(gap)
      } else {
        adjustedHeadline.bannerIndex = lastAdjustedHeadline.bannerIndex + gap
      }
    } else {
      // The first headline in the list
      adjustedHeadline.bannerIndex = TOTAL_WIDTH + moment().diff(currentHeadline.createdAt, "minutes") ** 0.8
    }
    adjustedHeadlines.push(adjustedHeadline)
  }

  return adjustedHeadlines
}

export { adjustBannerIndex }
export type { Headline, PlacedHeadline as HeadlinePlaced }
